<template>
  <div class="manual-listing">
    <div class="header-section">
      <img src="../../images/p2trade.svg" alt="Header Image" class="header-image" />
      <p class="header-text">Submit Trade</p>
    </div>
    <div class="manual-listing-form">
      <label for="date">Select Date</label>
      <div class="date-input-container">
        <input
          type="date"
          id="date"
          v-model="selectedDate"
          :min="minDate"
          @blur="validateField('date')"/>
        <span class="calendar-icon"><img src="../../images/p2pcalender.png" alt="calendar"></span>
      </div>
      <span v-if="errors.date" class="error">{{ errors.date }}</span>
      <label>Select Time Range</label>
      <div class="time-slider-container">
        <vue-slider
          v-model="timeRange"
          :min="0"
          :max="1440"
          :interval="30"
          :tooltip="'always'"
          :process-style="{ backgroundColor: '#13B78C' }"
          :formatter="formatTime"
          :tooltip-formatter="formatTooltip"
          @change="updateTimeRange"
        />
      </div>
      <div class="time-display">
        <span>Start Time:  {{ formatTime(timeRange[0]) }}</span>
        <span>End Time: {{ formatTime(timeRange[1]) }}</span>
      </div>
      <span v-if="errors.startTime" class="error">{{ errors.startTime }}</span>
      <span v-if="errors.endTime" class="error">{{ errors.endTime }}</span>
      <label for="price">{{ isSelling ? "Sell Price" : "Buy Price" }}</label>
      <input
        type="number"
        id="price"
        v-model="price"
        placeholder="Enter price"
        @blur="validateField('price')"
      />
      <span v-if="errors.price" class="error">{{ errors.price }}</span>
      <p class="trading_price">Trading Units</p>
      <span v-if="errors.unitsTraded" class="error">{{ errors.unitsTraded }}</span>
      <p class="card-heading" :style="{ color: violetColor }">
        {{ unitsTraded ? unitsTraded : 0 }} units
      </p>
      <input
        type="range"
        min="1"
        :max="plantSize * 5"
        :step="1"
        v-model="unitsTraded"
        @input="updateVioletFill"
        class="slider"
        :style="rangeBackgroundStyle"/>
      <span v-if="errors.general" class="error">{{ errors.general }}</span>
      <div class="button-group">
        <button :disabled="loading" @click="submitForm">
          {{ loading ? "Loading..." : "Submit" }}
        </button>
        <button @click="closeForm">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import TradeService from "@/services/trade.service";
import TransactionService from "@/services/transaction.service";
import { useToast } from "vue-toastification";
import { mapState } from "vuex";
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  components: {
    VueSlider
  },
  props: {
    isSelling: Boolean,
  },
  data() {
    return {
      selectedDate: this.getTomorrowDate(),
      timeRange: [this.get9AmInMinutes(), this.get5PmInMinutes()],
      price: "",
      unitsTraded: 1,
      loading: false,
      violetColor: "#13B78C",
      hasExceededThreshold: false,
      plantSize: 5,
      errors: {
        date: "",
        startTime: "",
        endTime: "",
        price: "",
        unitsTraded: "",
        general: "",
      },
    };
  },
  computed: {
    ...mapState({
      currentUserNode: (state) => state.currentUserNode,
    }),
    minDate() {
      return this.getTomorrowDate();
    },
    rangeBackgroundStyle() {
      const percentage = (this.unitsTraded / (this.plantSize * 5)) * 100;
      const threshold = this.plantSize * this.getSelectedTimeDuration() * 0.5;
      const isExceeded = this.unitsTraded > threshold;
      const thumbColor = isExceeded ? "#ff8c06" : this.violetColor;

      return {
        background: `linear-gradient(to right, ${this.violetColor} ${percentage}%, #ececec ${percentage}%)`,
        "--thumb-color": thumbColor,
      };
    },
    isFormValid() {
      return (
        !this.errors.date &&
        !this.errors.startTime &&
        !this.errors.endTime &&
        !this.errors.price &&
        !this.errors.unitsTraded &&
        !this.errors.general
      );
    },
  },
  mounted() {
    console.log('this.currentUserNode',this.currentUserNode);
    if (this.currentUserNode && this.currentUserNode?.hardwareGroups) {
      console.log('this.currentUserNode.hardwareGroups',this.currentUserNode.hardwareGroups);
      this.plantSize =
        this.currentUserNode?.props?.find((p) => p.prop == "plantSize")?.val ||
        this.currentUserNode?.hardwareGroups[0]?.devices[0]?.hardwareType.props.find(
          (p) => p.prop == "size"
        )?.val ||
        0;
      console.log('this.plantSize',this.plantSize);
    }
    this.timeRange = [this.get9AmInMinutes(), this.get5PmInMinutes()];
  },
  methods: {
    getTomorrowDate() {
      let tomorrow = new Date();
      // tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split("T")[0];
    },
    getCurrentTimeInMinutes() {
      let now = new Date();
      return now.getHours() * 60 + now.getMinutes();
    },
    get5PmInMinutes(){
      let now = new Date();
      return 17 * 60 + now.getMinutes();
    },
    get9AmInMinutes(){
      let now = new Date();
      return 9 * 60 + now.getMinutes();
    },
    formatTime(minutes) {
      const hours = Math.floor(minutes / 60).toString().padStart(2, '0');
      const mins = (minutes % 60).toString().padStart(2, '0');
      return `${hours}:${mins}`;
    },
    formatTooltip(value) {
      return this.formatTime(value);
    },
    updateTimeRange() {
      this.validateField('startTime');
      this.validateField('endTime');
      this.validateTimeRange();
    },
    validateTimeRange() {
      if (this.timeRange[1] <= this.timeRange[0]) {
        this.errors.endTime = "End time must be greater than start time.";
      } else {
        this.errors.endTime = "";
      }
    },
    getSelectedTimeDuration() {
      const duration = (this.timeRange[1] - this.timeRange[0]) / 60;
      return duration;
    },
    async submitForm() {
      this.validateAllFields();
      if (this.isFormValid) {
        try {
          this.loading = true;
          const actionType = this.isSelling ? "sell" : "buy";

          const { startTimestamp, endTimestamp } = this.convertToUnixTimestampInterval(
            this.selectedDate,
            this.formatTime(this.timeRange[0]),
            this.formatTime(this.timeRange[1])
          );
          const unitRate = parseFloat(this.price);
      const discomCharges = parseFloat((this.unitsTraded * 0.21).toFixed(2));
      const aggregatorFees = parseFloat((this.unitsTraded * 0.1).toFixed(2));
      const crossWheelingCharges = parseFloat((this.unitsTraded * 0.45).toFixed(2));
      const otherCharges = parseFloat((this.unitsTraded * 0.12).toFixed(2));
      const totalAmount = this.isSelling
        ? this.unitsTraded * unitRate - (discomCharges + aggregatorFees + crossWheelingCharges + otherCharges)
        : -(this.unitsTraded * unitRate + discomCharges + aggregatorFees + crossWheelingCharges + otherCharges);
      const transactionResponse = await TransactionService.createWalletTransaction(parseFloat(totalAmount.toFixed(2)), actionType, {
        unitRate,
        discomCharges,
        aggregatorFees,
        crossWheelingCharges,
        otherCharges,
      });
      if(!this.isSelling){
      const meta = await this.pollTransactionMeta(transactionResponse.id);
      if (!meta || !meta.order_id) {
        this.failed = true;
        this.loading = false;
        this.showToast("Transaction Failed", "Transaction Failed,Please try again.");
        return;
      }
      await TransactionService.updateWalletTransaction(transactionResponse.id);
    }

    // const userWallet = await TransactionService.getWallet();
    // const transactions=[...new Set([transactionResponse?.id, ...(userWallet[0].transactions || []).map((t) => t.id)])];
    // console.log(transactions,"logging transactions");
    // const updateResponse = await TransactionService.updateWallet(userWallet[0].id, transactions);
          

          const response = await TradeService.createP2PListing(
            {
              startTimestamp,
              endTimestamp,
              price: parseFloat(this.price),
              unitsTraded: parseFloat(this.unitsTraded),
            },
            this.isSelling ? "sell" : "buy"
          );
          if (response && response.id) {
            this.showToast("Success", "Created successfully");
            this.$emit("close");
            // Emit the refreshRecommends event to update the recommended cards
            this.$emit("refreshRecommends");
          } else {
            this.showToast("Error", "Failed to create listing");
          }
        } catch (error) {
          this.showToast("Error", "Failed to create listing");
          console.error(error);
        }
        this.loading = false;
      }
    },

    async pollTransactionMeta(transactionId, maxAttempts = 10, interval = 1000) {
  let attempts = 0;
  while (attempts < maxAttempts) {
    const trans = await TransactionService.getTransaction(transactionId);
    const meta = trans.meta ? JSON.parse(trans.meta) : null;
    if (meta && meta.order_id) {
      return meta;
    }
    await this.delay(interval);
    attempts++;
  }
  return null;
    },
  delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
},
    closeForm() {
      this.$emit("close");
    },
    convertToUnixTimestampInterval(dateStr, startTime, endTime) {
      return {
        startTimestamp: this.getUnixTimestamp(startTime, dateStr),
        endTimestamp: this.getUnixTimestamp(endTime, dateStr),
      };
    },
    getUnixTimestamp(timeStr, dateStr) {
      return Math.floor(new Date(`${dateStr}T${timeStr}:00Z`).getTime());
    },
    showToast(title, message) {
      const toast = useToast();
      toast.success(message, {
        title: title,
        timeout: 2000,
        position: "top-right",
      });
    },
    updateVioletFill() {
      const threshold = this.plantSize * this.getSelectedTimeDuration() * 0.5;
      console.log("Threshold:", threshold); // Debugging statement
      console.log("Units Traded:", this.unitsTraded); // Debugging statement

      if (this.unitsTraded > threshold) {
        if (!this.hasExceededThreshold) {
          this.errors.unitsTraded = "Trade check: Typical exports are lower than entered units";
          this.hasExceededThreshold = true;
        }
        this.violetColor = "#ff8c06";
      } else {
        this.errors.unitsTraded = "";
        this.violetColor = "#13B78C";
        this.hasExceededThreshold = false;
      }
    },
    validateField(field) {
      if (field === "date" && !this.selectedDate) {
        this.errors.date = "Date is required.";
      } else {
        this.errors.date = "";
      }

      if (field === "startTime" && !this.timeRange[0]) {
        this.errors.startTime = "Start time is required.";
      } else {
        this.errors.startTime = "";
      }

      if (field === "endTime" && !this.timeRange[1]) {
        this.errors.endTime = "End time is required.";
      } else {
        this.errors.endTime = "";
      }

      if (field === "price") {
        if (!this.price) {
          this.errors.price = "Price is required.";
        } else if (this.price <= 0) {
          this.errors.price = "Price must be greater than zero.";
        } else {
          this.errors.price = "";
        }
      }

      if (field === "unitsTraded") {
        if (this.unitsTraded === 0) {
          this.errors.unitsTraded = "Units traded must be greater than zero.";
        } else {
          this.errors.unitsTraded = "";
        }
      }
    },
    validateAllFields() {
      this.validateField('date');
      this.validateField('startTime');
      this.validateField('endTime');
      this.validateField('price');
      this.validateField('unitsTraded');
      this.validateTimeRange();

      if (!this.selectedDate || !this.timeRange[0] || !this.timeRange[1] || !this.price || this.unitsTraded === 0) {
        this.errors.general = "All fields are required.";
      } else {
        this.errors.general = "";
      }
    },
  },
};
</script>



<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

.manual-listing {
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}
.manual-listing-form {
  padding: 20px 30px;
}
.header-section {
  padding: 25px;
  background: linear-gradient(to bottom, #150C54, #453A94, #6857E5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 20px 20px 0 0;
}
.date-input-container {
  position: relative;
  text-align: left;
}
.calendar-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #453a94;
}
.header-text {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  margin: 0;
  margin-top: 20px;
  font-family: "Montserrat";
}
.trading_price {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 0;
  color: #909090;
  text-align: left;
  font-family: "Montserrat";
}
label {
  display: block;
  font-size: 14px;
  color: #909090;
  font-weight: 500;
  margin-top: 10px;
  text-align: left;
  font-family: "Montserrat";
}
input,
select {
  width: 100%;
  padding: 5px 15px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  background-color: white;
  color:#000;
  font-weight: 600;
}
input[type="date"],
select {
  appearance: none;
  color: #000;
  font-weight: 600;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  font-family: "Montserrat";
  text-align: left !important;
}
select {
  background-image: url("../../images/p2parrow.png");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 20px;
}
input[type="date"] {
  text-align: left !important;
  font-weight: 600;
  font-size: 14px;
  padding-right: 10px;
}
button {
  width: 48%;
  padding: 5px;
  margin-top: 15px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #453a94;
  color: #453a94;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  font-family: "Montserrat";
}
button:active {
  background: #453a94;
  color: #fff;
}
.button-group {
  display: flex;
  justify-content: space-between;
}
.card-heading {
  font-size: 13px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  color: #13B78C;
  margin: 0;
}
.error {
  color: rgb(255, 140, 6);
  font-size: 11px;
  margin-top: 5px;
}
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #453a94;
  font-family: "Montserrat";
}
.slider {
  -webkit-appearance: none;
  height: 0px;
  border-radius: 15px;
  background: #E6E6E6;
  outline: none;
  padding: 3px !important;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--thumb-color, #13B78C);
  cursor: pointer;
  transition: background 0.3s;
}
.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--thumb-color, #13B78C);
  cursor: pointer;
  transition: background 0.3s;
}
.time-slider-container {
  margin-top: 10px;
}
.time-display {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 10px;
  color: #909090;
  font-family: "Montserrat";
}
</style>
